import { emptyPlaceholder } from '../../constants';

export const threeWay = ["1", "x", "2"];
export const threeWayMargin = [emptyPlaceholder, "1", "x", "2"];
export const winner = ["1", emptyPlaceholder, "2"];
export const yesNo = ["y", emptyPlaceholder, "n"];
export const overUnder = [emptyPlaceholder, "+", "-"];
export const doubleChance = ["1x", "12", "x2"];
export const homeAway = [emptyPlaceholder, "1", "2"];